import { gql } from "graphql-tag"

const helpers = gql`
  type DeleteResponse {
    "Status"
    status: String!
  }
`

export default helpers
